import { MAIN_ROUTES, RESOURCES_ROUTES } from "../utils/routes";

const footerContent = {
  addressLines: [
    "School of Computing, NUS COM1-01-07, 13 Computing Drive,",
    "Singapore 117417",
  ],
  email: "dbsystem@comp.nus.edu.sg",
  navigationGroups: [
    [
      MAIN_ROUTES.get("HOME"),
      MAIN_ROUTES.get("PEOPLE"),
    ],
    [
      MAIN_ROUTES.get("PUBLICATIONS"),
      MAIN_ROUTES.get("PROJECTS"),
    ],
    [
      RESOURCES_ROUTES.get("BLOG_LIST"),
      RESOURCES_ROUTES.get("EVENTS_LIST"),
    ],
    [MAIN_ROUTES.get("GITHUB"), MAIN_ROUTES.get("CONTACT")],
  ],
};

export default footerContent;
